"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const result_1 = __importDefault(require("./result"));
class PeliasRequest {
    constructor(options) {
        this.baseUrl = options.baseUrl || "https://api.geocode.earth/";
        this.layers = options.locationType || "locality";
        this.limit = options.limit;
        this.api_key = options.apiKey;
        this.autoCompleteEndpoint = "v1/autocomplete";
        this.reverseEndpoint = "v1/reverse";
    }
    autocomplete(term) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.makeRequest(this.autoCompleteEndpoint, { text: term });
        });
    }
    reverseGeocode(latitude, longitude) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.makeRequest(this.reverseEndpoint, {
                "point.lat": latitude.toString(),
                "point.lon": longitude.toString(),
            });
        });
    }
    makeRequest(endpoint, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const fullParams = new URLSearchParams(Object.assign(Object.assign({ api_key: this.api_key, layers: this.layers }, (this.limit && { size: this.limit })), params));
            const url = this.url(endpoint, fullParams.toString());
            const result = yield (0, cross_fetch_1.default)(url);
            const json = (yield result.json());
            return json.features.map((location) => new result_1.default(location));
        });
    }
    url(endpoint, params) {
        return `${this.baseUrl}${endpoint}?${params}`;
    }
}
exports.default = PeliasRequest;
